import type {ReactElement} from 'react';
import {getAssetUrl} from '@Utils/s3.util';
import type {AiChatChristmasAssetImageProps} from './ai-chat-christmas-asset-image.types';

export function AiChatChristmasAssetImage({asset, className, onAnimationEnd}: AiChatChristmasAssetImageProps): ReactElement {
  return <img className={className} src={getAssetUrl(asset)} alt="" draggable={false} onAnimationEnd={onAnimationEnd} />;
}
